import AppIconNameSettings from './AppIconNameSettings';

export default AppIconNameSettings;
